import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=21ad0d9c&scoped=true&"
import script from "./pill.vue?vue&type=script&lang=js&"
export * from "./pill.vue?vue&type=script&lang=js&"
import style0 from "./pill.vue?vue&type=style&index=0&id=21ad0d9c&lang=scss&scoped=true&"
import style1 from "./pill.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad0d9c",
  null
  
)

export default component.exports